var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"message-divider"},[_c('div',{staticClass:"message-divider__line"}),_c('div',{staticClass:"message-divider__text"},[_vm._v(_vm._s(_vm.text))]),_c('div',{staticClass:"message-divider__line"})])}
var staticRenderFns = []

export { render, staticRenderFns }